import { Component, input } from '@angular/core';

@Component({
  selector: 'app-gear-icon',
  imports: [],
  templateUrl: './gear-icon.html',
  styleUrl: './gear-icon.scss',
})
export class GearIcon {
  isSystemConfigsOpen = input();
}
